export const lightTheme = {
  // Background colors
  bgPrimary: '#ffffff',
  bgSecondary: '#f9fafb',
  bgTertiary: '#f3f4f6',
  
  // Text colors
  textPrimary: '#111827',
  textSecondary: '#374151',
  textMuted: '#6b7280',
  
  // Border colors
  borderPrimary: '#e5e7eb',
  borderSecondary: '#d1d5db',
  borderFocus: '#9333ea', // purple-600
  
  // Component specific backgrounds
  headerBg: 'rgba(255, 255, 255, 0.8)',
  footerBg: '#f9fafb',
  cardBg: '#ffffff',
  
  // Input colors
  inputBg: '#ffffff',
  inputBorder: '#e5e7eb',
  inputBorderHover: '#d1d5db',
  inputBorderFocus: '#9333ea',
  
  // Progress bar
  progressBg: '#e5e7eb',
  progressFill: '#9333ea',
  
  // Selected state (for light mode)
  selectedBg: '#f3e8ff',  // Light purple background (purple-50)
  selectedBorder: '#9333ea',  // Purple border (purple-600)
  
  // Error colors
  errorBg: 'rgba(254, 226, 226, 0.3)',
  errorBorder: '#fca5a5',
  errorText: '#dc2626',
  
  // Transitions
  transition: 'all 0.3s ease',
  transitionSlow: 'all 0.5s ease',
};

export const darkTheme = {
  // Background colors
  bgPrimary: '#1a1d29',
  bgSecondary: '#1f2937',
  bgTertiary: '#374151',
  
  // Text colors
  textPrimary: '#ffffff',
  textSecondary: '#e5e7eb',
  textMuted: '#9ca3af',
  
  // Border colors
  borderPrimary: '#374151',
  borderSecondary: '#4b5563',
  borderFocus: '#a855f7', // purple-500
  
  // Component specific backgrounds
  headerBg: 'rgba(26, 29, 41, 0.8)',
  footerBg: 'rgba(31, 41, 55, 0.5)',
  cardBg: '#1f2937',
  
  // Input colors
  inputBg: '#1f2937',
  inputBorder: '#374151',
  inputBorderHover: '#4b5563',
  inputBorderFocus: '#a855f7',
  
  // Progress bar
  progressBg: '#374151',
  progressFill: '#a855f7',
  
  // Selected state (for dark mode)
  selectedBg: '#3b1f56',  // Darker purple background
  selectedBorder: '#a855f7',  // Brighter purple border (purple-500)
  
  // Error colors
  errorBg: 'rgba(127, 29, 29, 0.1)',
  errorBorder: '#991b1b',
  errorText: '#f87171',
  
  // Transitions
  transition: 'all 0.3s ease',
  transitionSlow: 'all 0.5s ease',
};
